import http from '../plugins/http';

export default {
  list: (n = 10) => http.get('/treatment', {
    params: { per_page: n, page: 1 }
  })
};
